//External libraries
import React, { useState } from 'react';
import { FloatingLabelSelect } from '@checkout/react-components';

//Internal modules
import { handleLanguageChange } from '../shared';
import { languageSelectorStyles } from './styles';
import { useMountLogging } from '@/lib/reactHooks';
import { features, getContent, getLocale } from '@/lib';
import { LanguageDropdownContainer } from './StyledComponents';

const LanguageDropdown = () => {
  useMountLogging('LanguageSelector');

  // should move current language to redux store later for footer and header
  const [language, setLanguage] = useState(getLocale().language);

  const handleChange = (e, newValue) => {
    setLanguage(newValue);
    handleLanguageChange(newValue);
  };

  const languageOptions = features.config.enabledLanguages.map(language => ({
    key: language,
    text: getContent(`languages.${language}`),
    value: language,
  }));

  return (
    <LanguageDropdownContainer>
      <FloatingLabelSelect
        changeHandler={handleChange}
        floatingLabelContainerStyleOverrides={languageSelectorStyles}
        id="languageSelector"
        label={getContent('languages.label', {
          language: getContent(`languages.${language}`),
        })}
        selectOptions={languageOptions}
        value={language}
      />
    </LanguageDropdownContainer>
  );
};

export { LanguageDropdown };
